/*
Copyright (C) 2026  Integrated Tech9labs Pvt. Ltd.
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import { action, observable } from "mobx";

/*
 * State the Swift shell shares between the sidebar and the top bar:
 *   collapsed   the sidebar folded to its icon rail (the top bar's menu button), kept in
 *               localStorage; with nothing stored, narrow windows start folded.
 *   itemTitle   the name of the item a details page shows, for the breadcrumb's last step.
 */
const COLLAPSED_KEY = "swift_sidebar_collapsed";
const NARROW = 1100;

const readCollapsed = (): boolean => {
  try {
    const stored = window.localStorage.getItem(COLLAPSED_KEY);
    if (stored === "true" || stored === "false") return stored === "true";
  } catch (e) {
    // storage blocked: fall back to the window width
  }
  return typeof window !== "undefined" && window.innerWidth <= NARROW;
};

class ShellStore {
  @observable collapsed: boolean = readCollapsed();

  @observable itemTitle: string | null = null;

  @action toggleCollapsed() {
    this.setCollapsed(!this.collapsed);
  }

  @action setCollapsed(collapsed: boolean) {
    this.collapsed = collapsed;
    try {
      window.localStorage.setItem(COLLAPSED_KEY, String(collapsed));
    } catch (e) {
      // not remembered, still applied
    }
  }

  @action setItemTitle(title: string | null | undefined) {
    this.itemTitle = title || null;
  }
}

export default new ShellStore();
